import React, { useState, useEffect, useRef } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./Visiting.css";

import "./fonts/NotoSansMalayalam-Regular-normal";

import Quill from "quill";
import "quill/dist/quill.snow.css";

import { API_BASE } from "../apiConfig";

export default function Visiting() {
// ============================================================
  // POPUP STATES
  // ============================================================

  const [showPrescriptionPopup, setShowPrescriptionPopup] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [popupEditMode, setPopupEditMode] = useState(false);
  const [popupPrescription, setPopupPrescription] = useState("");

  // ============================================================
  // SIDEBAR
  // ============================================================

  const [open, setOpen] = useState(true);

  useEffect(() => {

    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);

  // ============================================================
  // PATIENT DATA
  // ============================================================

  const [formData, setFormData] = useState({
    name: "",
    bname: "",
    phone: "",
    age: "",
    sex: "",
    star: "",
    remarks: "",
    mr_no: "",
    prescription: ""
  });

  // ============================================================
  // QUILL
  // ============================================================

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {

    if (!editorRef.current) return;

    if (quillRef.current) return;

    const container = editorRef.current;

    quillRef.current = new Quill(container, {
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          [{ align: [] }]
        ]
      }
    });

    quillRef.current.root.innerHTML =
      formData.prescription || "";

    quillRef.current.on("text-change", () => {

      const html =
        quillRef.current.root.innerHTML;

      setFormData(prev => ({
        ...prev,
        prescription: html
      }));

    });

    return () => {
      quillRef.current = null;
    };

  }, []);

  // ============================================================
  // SEARCH FORM
  // ============================================================

  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
    mr_no: ""
  });

  const [data, setData] = useState([]);

  const [showTable, setShowTable] = useState(false);

  const [loading, setLoading] = useState(false);

  const [editId, setEditId] = useState(null);

  // ============================================================
  // MR NO CHANGE
  // ============================================================

  const handleSearchChange = (e) => {

    const value = e.target.value;

    // Allow:
    // MR001
    // MR-001
    // mr001

    setForm(prev => ({
      ...prev,
      mr_no: value
    }));

  };

  // ============================================================
  // VALIDATE SEARCH
  // ============================================================

  const validateForm = () => {

    if (!form.mr_no.trim()) {
      return "Enter MR No. to get patient details";
    }

    return null;
  };

  // ============================================================
  // SEARCH PATIENT BY MR NO
  // ============================================================

  const handleSearch = async () => {

  const mrNo = form.mr_no?.trim();

  if (!mrNo) {

    Swal.fire({
      icon: "warning",
      title: "MR No.",
      text: "Please enter MR Number"
    });

    return;
  }


  setShowTable(false);
  setLoading(true);


  try {

    const apiUrl =
      `${API_BASE}search_patient.php?mr_no=${encodeURIComponent(mrNo)}`;


    console.log("Searching MR No:", mrNo);
    console.log("API URL:", apiUrl);


    const response = await fetch(apiUrl);


    const text = await response.text();

    console.log("API STATUS:", response.status);
    console.log("API RESPONSE:", text);


    let result;

    try {

      result = JSON.parse(text);

    } catch (jsonError) {

      console.error("Invalid JSON:", text);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "The PHP API did not return valid JSON."
      });

      return;
    }


    // ======================================================
    // SERVER ERROR
    // ======================================================

    if (!response.ok) {

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text:
          result.message ||
          `Server returned error ${response.status}`
      });

      return;
    }


    // ======================================================
    // PATIENT FOUND
    // ======================================================

    //  if (result.success && result.believer) {
    if (result.believer) {

      console.log("Patient:", result.believer);
      console.log("Visits:", result.visits);


      setFormData(result.believer);


      setData(
        result.visits || []
      );


      setShowTable(true);


    } else {

      // Patient not found

      setData([]);

      setShowTable(false);


      Swal.fire({
        icon: "info",
        title: "Patient Not Found",
        text:
          result.message ||
          "No patient found with this MR Number."
      });

    }


  } catch (error) {

    console.error("FETCH ERROR:", error);


    Swal.fire({
      icon: "error",
      title: "Failed to Fetch",
      text:
        "Unable to connect to the server. Please check the API URL and server connection."
    });


  } finally {

    setLoading(false);

  }

};

  // ============================================================
  // SAVE / UPDATE PRESCRIPTION
  // ============================================================

  const handleSave = async () => {

    if (!formData.mr_no) {

      Swal.fire(
        "Error",
        "MR No. required",
        "warning"
      );

      return;
    }

    if (!formData.phone) {

      Swal.fire(
        "Error",
        "Patient phone number is missing",
        "warning"
      );

      return;
    }

    if (!formData.prescription?.trim()) {

      Swal.fire(
        "Warning",
        "Prescription cannot be empty",
        "warning"
      );

      return;
    }

    const url = editId
      ? `${API_BASE}update_visit.php`
      : `${API_BASE}save_visit.php`;

    try {

      Swal.fire({
        title: editId
          ? "Updating..."
          : "Saving...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const res = await fetch(url, {

        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({

          ...formData,

          id: editId,

          mr_no: formData.mr_no

        })

      });

      if (!res.ok) {
        throw new Error(`HTTP Error ${res.status}`);
      }

      const result = await res.json();

      console.log("Save result:", result);

      if (!result.success) {

        Swal.fire(
          "Error",
          result.message ||
          (editId
            ? "Failed to update data"
            : "Failed to save data"),
          "error"
        );

        return;
      }

      Swal.fire({
        icon: "success",
        title: editId
          ? "Updated Successfully"
          : "Saved Successfully",
        text: "Visit details have been saved.",
        timer: 1800,
        showConfirmButton: false
      });

      setEditId(null);

      await handleSearch();

    } catch (err) {

      console.error("Save error:", err);

      Swal.fire(
        "Error",
        "Something went wrong",
        "error"
      );

    }

  };

  // ============================================================
  // OPEN VISIT POPUP
  // ============================================================

  const handleEdit = (row) => {

    setSelectedVisit(row);

    setPopupPrescription(
      row.prescription || ""
    );

    setPopupEditMode(false);

    setShowPrescriptionPopup(true);

  };

  // ============================================================
  // UPDATE POPUP PRESCRIPTION
  // ============================================================

  const handlePopupUpdate = async () => {

    if (!popupPrescription.trim()) {

      Swal.fire(
        "Warning",
        "Prescription cannot be empty",
        "warning"
      );

      return;
    }

    try {

      Swal.fire({
        title: "Updating...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await fetch(
        `${API_BASE}update_visit.php`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({

            id: selectedVisit.id,

            mr_no:
              formData.mr_no ||
              selectedVisit.mr_no ||
              "",

            prescription:
              popupPrescription,

            name:
              formData.name ||
              selectedVisit.name ||
              "",

            phone:
              formData.phone ||
              selectedVisit.phone ||
              "",

            age:
              formData.age ||
              selectedVisit.age ||
              "",

            sex:
              formData.sex ||
              selectedVisit.sex ||
              "",

            star:
              formData.star ||
              selectedVisit.star ||
              "",

            remarks:
              selectedVisit.remarks ||
              ""

          })

        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP Error ${response.status}`
        );
      }

      const result = await response.json();

      console.log(
        "Popup update result:",
        result
      );

      if (result.success) {

        setSelectedVisit(prev => ({
          ...prev,
          prescription:
            popupPrescription
        }));

        setPopupEditMode(false);

        await handleSearch();

        Swal.fire({
          icon: "success",
          title: "Updated",
          text:
            "Prescription updated successfully",
          timer: 1500,
          showConfirmButton: false
        });

      } else {

        Swal.fire(
          "Error",
          result.message ||
          "Failed to update prescription",
          "error"
        );

      }

    } catch (error) {

      console.error(
        "Popup update error:",
        error
      );

      Swal.fire(
        "Error",
        "Something went wrong while updating",
        "error"
      );

    }

  };

  // ============================================================
  // PRINT
  // ============================================================

  const handlePrint = (row) => {

    const printWindow =
      window.open("", "_blank");

    if (!printWindow) {

      Swal.fire(
        "Popup Blocked",
        "Please allow popups for printing.",
        "warning"
      );

      return;
    }

    const name =
      row.name ||
      formData.name ||
      "";

    const bname =
      row.bname ||
      formData.bname ||
      "";

    const star =
      row.star ||
      formData.star ||
      "";

    const age =
      row.age ||
      formData.age ||
      "";

    const native =
      row.native ||
      formData.native ||
      "";

    const prescription =
      row.prescription ||
      "";

    const formatPrintDate =
      (dateString) => {

        if (!dateString) return "";

        const d =
          new Date(
            dateString.replace(
              " ",
              "T"
            )
          );

        return new Intl.DateTimeFormat(
          "en-IN",
          {
            timeZone:
              "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          }
        ).format(d);

      };

    const formattedDate =
      formatPrintDate(
        row.visit_date
      );

    const splitByHeight =
      (text, heights) => {

        const words =
          text.split(" ");

        const pages = [];

        const temp =
          document.createElement(
            "div"
          );

        temp.style.position =
          "absolute";

        temp.style.visibility =
          "hidden";

        temp.style.width =
          "480px";

        temp.style.fontFamily =
          "Noto Sans Malayalam, Tahoma";

        temp.style.fontSize =
          "14px";

        temp.style.lineHeight =
          "1.3";

        temp.style.whiteSpace =
          "pre-wrap";

        temp.style.wordBreak =
          "break-word";

        document.body.appendChild(
          temp
        );

        let current = "";

        let pageIndex = 0;

        words.forEach(word => {

          const test =
            current +
            word +
            " ";

          temp.innerText =
            test;

          const maxHeight =
            pageIndex === 0
              ? heights.firstPage
              : heights.otherPages;

          if (
            temp.offsetHeight >
            maxHeight
          ) {

            pages.push(
              current.trim()
            );

            current =
              word + " ";

            pageIndex++;

          } else {

            current = test;

          }

        });

        if (current.trim()) {
          pages.push(
            current.trim()
          );
        }

        document.body.removeChild(
          temp
        );

        return pages;
      };

    const prescriptionPages =
      splitByHeight(
        prescription,
        {
          firstPage: 360,
          otherPages: 450
        }
      );

    printWindow.document.write(`

      <html>

      <head>

        <title>Print</title>

        <style>

          @page {
            size: A5;
            margin: 0;
          }

          body {
            margin: 0;
            font-family:
              "Noto Sans Malayalam",
              Tahoma;
          }

          .header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 220px;
            background-image:
              url('/images/Astrologer-.jpeg');
            background-size: cover;
            background-repeat: no-repeat;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
            text-align: center;
            font-size: 12px;
            background: black;
            color: white;
          }

          .page {
            page-break-after: always;
            break-after: page;
            height: 100vh;
            box-sizing: border-box;
            padding-top: 220px;
            padding-bottom: 50px;
            padding-left: 55px;
            padding-right: 40px;
          }

          .prescription {
            margin-top: 20px;
            white-space: pre-wrap;
            word-break: break-word;
            line-height: 1.3;
            font-size: 14px;
          }

        </style>

      </head>

      <body>

        <div class="header"></div>

        <div class="footer">
          <p>
            Time: 9 am to 6 pm |
            ഞായർ അവധി |
            Kolath Medicals
          </p>
        </div>

        ${prescriptionPages
          .map(
            (chunk, index) => `

              <div class="page">

                ${
                  index === 0
                    ? `

                    <p style="text-align:right;">
                      <strong>Date:</strong>
                      ${formattedDate}
                    </p>

                    <p style="margin-top:30px">

                      ${native}
                      ${bname}
                      <br/>

                      ${star}
                      ${name},
                      Age: ${age}

                    </p>

                  `
                    : ""
                }

                <div class="prescription">

                  ${chunk}

                </div>

              </div>

            `
          )
          .join("")}

        <script>

          window.onload =
            function() {

              window.print();

              setTimeout(
                () => window.close(),
                500
              );

            };

        </script>

      </body>

      </html>

    `);

    printWindow.document.close();

  };

  // ============================================================
  // DELETE VISIT
  // ============================================================

  const handleDelete = (id) => {

    Swal.fire({

      title: "Are you sure?",

      text:
        "This visit will be deleted",

      icon: "warning",

      showCancelButton: true,

      confirmButtonText:
        "Yes, delete it"

    }).then(async result => {

      if (!result.isConfirmed)
        return;

      try {

        const res =
          await fetch(
            `${API_BASE}delete_visit.php?id=${id}`
          );

        const response =
          await res.json();

        if (response.success) {

          Swal.fire(
            "Deleted!",
            "Visit removed",
            "success"
          );

          handleSearch();

        } else {

          Swal.fire(
            "Error",
            response.message ||
            "Unable to delete visit",
            "error"
          );

        }

      } catch (err) {

        console.error(err);

        Swal.fire(
          "Error",
          "Unable to delete visit",
          "error"
        );

      }

    });

  };

  // ============================================================
  // CANCEL
  // ============================================================

  const handleCancel = () => {

    setFormData(prev => ({
      ...prev,
      prescription: ""
    }));

    setEditId(null);

  };

  // ============================================================
  // EXPORT EXCEL
  // ============================================================

  const exportToExcel = () => {

    const exportData =
      data.map((row, i) => ({

        "Sl No":
          i + 1,

        "MR No":
          row.mr_no || "",

        Name:
          row.name || "",

        Age:
          row.age || "",

        Gender:
          row.sex || "",

        Star:
          row.star || "",

        Phone:
          row.phone || "",

        Date:
          row.visit_date || ""

      }));

    const worksheet =
      XLSX.utils.json_to_sheet(
        exportData
      );

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Visit History"
    );

    const excelBuffer =
      XLSX.write(
        workbook,
        {
          bookType: "xlsx",
          type: "array"
        }
      );

    const blob =
      new Blob(
        [excelBuffer],
        {
          type:
            "application/octet-stream"
        }
      );

    saveAs(
      blob,
      "Visit-History.xlsx"
    );

  };

  // ============================================================
  // RENDER
  // ============================================================

  return (

    <div className="container-fluid p-0">

      <div
        className="d-flex"
        style={{
          height: "100vh"
        }}
      >

        {/* ======================================================
            SIDEBAR TOGGLE
        ====================================================== */}

        <div
          className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
          style={{
            zIndex: 999,
            cursor: "pointer",
            position: "fixed",
            left:
              open
                ? "350px"
                : "60px",
            top: "0",
            transition:
              "left 0.3s ease"
          }}
          onClick={() =>
            setOpen(!open)
          }
        >

          <span
            className="displaysidemenu"
            style={{
              position:
                "absolute",
              right:
                "-10px"
            }}
          >
            ☰
          </span>

        </div>


        {/* ======================================================
            LEFT SIDEBAR
        ====================================================== */}

        <div
          className="border-end leftcolor"
          style={{
            width:
              open
                ? "350px"
                : "0",

            overflow:
              "hidden",

            transition:
              "0.3s ease"
          }}
        >

          {open && (

            <div className="p-3">

              <AdminLeft />

            </div>

          )}

        </div>


        {/* ======================================================
            RIGHT CONTENT
        ====================================================== */}

        <div
          className="p-4"
          style={{
            width:
              open
                ? "calc(100% - 350px)"
                : "100%",

            transition:
              "0.3s ease",

            paddingLeft:
              "30px"
          }}
        >

          <TopBanner />


          <div
            className="visiting-page"
            style={{
              height: "80vh",
              overflow: "auto",
              padding: "25px",
              paddingBottom:
                "100px"
            }}
          >

            <div className="visiting-container">

              {/* ==================================================
                  SEARCH
              ================================================== */}

              <div className="visiting-search-card">

                <h2 className="search-title">
                  Patient Visit
                </h2>

                <p className="search-subtitle">
                  Search patient details using MR No.
                </p>


                <div className="search-row">

                  <div className="phone-wrapper">

                    <i className="fa fa-id-card phone-icon"></i>

                    <input
                      className="phone-input"
                      name="mr_no"
                      placeholder="Enter MR No."
                      value={
                        form.mr_no
                      }
                      onChange={
                        handleSearchChange
                      }
                      onKeyDown={e => {

                        if (
                          e.key ===
                          "Enter"
                        ) {
                          handleSearch();
                        }

                      }}
                    />

                  </div>


                  <button
                    className="search-btn"
                    onClick={
                      handleSearch
                    }
                    disabled={
                      loading
                    }
                  >

                    <i className="fa fa-search"></i>

                    &nbsp;

                    {loading
                      ? "Searching..."
                      : "Search Patient"}

                  </button>

                </div>


                {loading && (

                  <div className="loading-message">

                    <i className="fa fa-spinner fa-spin"></i>

                    &nbsp;

                    Searching patient...

                  </div>

                )}

              </div>


              {/* ==================================================
                  PATIENT WORKSPACE
              ================================================== */}

              {showTable && (

                <div
                  className="visiting-workspace"
                >

                  {/* ==================================================
                      PATIENT CARD
                  ================================================== */}

                  <div className="patient-card">

                    <div className="card-header-modern">

                      <div className="card-title-area">

                        <div className="card-title-icon">

                          <i className="fa fa-user-md"></i>

                        </div>

                        <div>

                          <h3 className="card-title">
                            Patient Details
                          </h3>

                          <p className="card-subtitle">
                            Patient information & prescription
                          </p>

                        </div>

                      </div>

                    </div>


                    {/* PATIENT INFORMATION */}

                    <div className="patient-info">

                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          MR No.
                        </span>

                        <span className="patient-info-value">

                          {formData.mr_no ||
                            "-"}

                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Name
                        </span>

                        <span className="patient-info-value">

                          {formData.name ||
                            "-"}

                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Phone
                        </span>

                        <span className="patient-info-value">

                          {formData.phone ||
                            "-"}

                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Age
                        </span>

                        <span className="patient-info-value">

                          {formData.age ||
                            "-"}

                        </span>

                      </div>


                      <div className="patient-info-item">

                        <span className="patient-info-label">
                          Gender
                        </span>

                        <span className="patient-info-value">

                          {formData.sex ||
                            "-"}

                        </span>

                      </div>

                    </div>


                    {/* ==================================================
                        PRESCRIPTION
                    ================================================== */}

                    <div className="prescription-section">

                      <div className="prescription-label-row">

                        <label className="prescription-label">

                          <i className="fa fa-file-text-o"></i>

                          &nbsp;

                          New Prescription

                        </label>

                        <span className="prescription-hint">
                          Enter consultation details
                        </span>

                      </div>


                      <div className="prescription-editor-wrapper">

                        <textarea
                          className="prescription-editor"
                          value={
                            formData.prescription ||
                            ""
                          }
                          onChange={e =>
                            setFormData({
                              ...formData,
                              prescription:
                                e.target.value
                            })
                          }
                          placeholder="Enter Prescription..."
                        />

                      </div>


                      <div className="prescription-actions">

                        <button
                          className="save-btn"
                          onClick={
                            handleSave
                          }
                        >

                          <i className="fa fa-save"></i>

                          &nbsp;

                          Save Prescription

                        </button>


                        <button
                          className="cancel-btn"
                          onClick={
                            handleCancel
                          }
                        >

                          <i className="fa fa-times"></i>

                          &nbsp;

                          Cancel

                        </button>

                      </div>

                    </div>

                  </div>


                  {/* ==================================================
                      HISTORY
                  ================================================== */}

                  <div className="history-card">

                    <div className="history-header">

                      <h3 className="history-title">

                        <i className="fa fa-history"></i>

                        &nbsp;

                        Visit History

                      </h3>

                      <p className="history-subtitle">
                        Previous consultations
                      </p>

                    </div>


                    <div className="history-table-wrapper">

                      <table className="history-table">

                        <thead>

                          <tr>

                            <th style={{
                              width: "10%"
                            }}>
                              No.
                            </th>

                            <th style={{
                              width: "30%"
                            }}>
                              Visited Date
                            </th>

                            <th style={{
                              width: "60%"
                            }}>
                              Actions
                            </th>

                          </tr>

                        </thead>


                        <tbody>

                          {data.length > 0
                            ? (

                              data.map(
                                (row, i) => (

                                  <tr
                                    key={
                                      row.id
                                    }
                                  >

                                    <td>

                                      <span className="visit-number">
                                        {i + 1}
                                      </span>

                                    </td>


                                    <td>

                                      {row.visit_date
                                        ? new Intl.DateTimeFormat(
                                          "en-IN",
                                          {
                                            timeZone:
                                              "Asia/Kolkata",

                                            day:
                                              "2-digit",

                                            month:
                                              "short",

                                            year:
                                              "numeric",

                                            hour:
                                              "2-digit",

                                            minute:
                                              "2-digit",

                                            hour12:
                                              true
                                          }
                                        ).format(
                                          new Date(
                                            row.visit_date.replace(
                                              " ",
                                              "T"
                                            )
                                          )
                                        )
                                        : "-"}

                                    </td>


                                    <td>

                                      <div className="history-actions">

                                        {/* VIEW */}

                                        <button
                                          className="history-action view"
                                          title="View / Edit"
                                          onClick={() =>
                                            handleEdit(
                                              row
                                            )
                                          }
                                        >

                                          <i className="fa fa-eye"></i>

                                        </button>


                                        {/* DELETE */}

                                        <button
                                          className="history-action delete"
                                          title="Delete"
                                          onClick={() =>
                                            handleDelete(
                                              row.id
                                            )
                                          }
                                        >

                                          <i className="fa fa-trash"></i>

                                        </button>


                                        {/* PRINT */}

                                        <button
                                          className="history-action print"
                                          title="Print"
                                          onClick={() =>
                                            handlePrint(
                                              row
                                            )
                                          }
                                        >

                                          <i className="fa fa-print"></i>

                                        </button>

                                      </div>

                                    </td>

                                  </tr>

                                )
                              )

                            )
                            : (

                              <tr>

                                <td
                                  colSpan="3"
                                  style={{
                                    textAlign:
                                      "center",
                                    padding:
                                      "35px"
                                  }}
                                >

                                  No visit history found

                                </td>

                              </tr>

                            )}

                        </tbody>

                      </table>

                    </div>

                  </div>

                </div>

              )}

            </div>

          </div>

        </div>

      </div>


      {/* ==========================================================
          PRESCRIPTION POPUP
      ========================================================== */}

      {showPrescriptionPopup &&
        selectedVisit && (

          <div
            style={{
              position:
                "fixed",

              top: 0,

              left: 0,

              width: "100%",

              height: "100%",

              background:
                "rgba(0,0,0,0.65)",

              zIndex:
                99999,

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",

              padding:
                "20px"
            }}
          >

            <div
              style={{
                width:
                  "700px",

                maxWidth:
                  "100%",

                maxHeight:
                  "90vh",

                background:
                  "#fff",

                borderRadius:
                  "10px",

                boxShadow:
                  "0 10px 40px rgba(0,0,0,0.3)",

                overflow:
                  "hidden",

                display:
                  "flex",

                flexDirection:
                  "column"
              }}
            >

              {/* HEADER */}

              <div
                style={{
                  background:
                    "#004962",

                  color:
                    "#fff",

                  padding:
                    "15px 20px",

                  display:
                    "flex",

                  justifyContent:
                    "space-between",

                  alignItems:
                    "center"
                }}
              >

                <div>

                  <h5
                    style={{
                      margin: 0,
                      color: "#fff",
                      fontWeight:
                        "600"
                    }}
                  >
                    Prescription Details
                  </h5>

                  <small>

                    Visit Date:{" "}

                    {selectedVisit.visit_date
                      ? new Intl.DateTimeFormat(
                        "en-IN",
                        {
                          timeZone:
                            "Asia/Kolkata",

                          day:
                            "2-digit",

                          month:
                            "2-digit",

                          year:
                            "numeric",

                          hour:
                            "2-digit",

                          minute:
                            "2-digit",

                          hour12:
                            true
                        }
                      ).format(
                        new Date(
                          selectedVisit.visit_date.replace(
                            " ",
                            "T"
                          )
                        )
                      )
                      : ""}

                  </small>

                </div>


                <button
                  onClick={() => {

                    setShowPrescriptionPopup(
                      false
                    );

                    setPopupEditMode(
                      false
                    );

                  }}
                  style={{
                    background:
                      "transparent",

                    border:
                      "none",

                    color:
                      "#fff",

                    fontSize:
                      "25px",

                    cursor:
                      "pointer"
                  }}
                >
                  ×
                </button>

              </div>


              {/* PATIENT INFORMATION */}

              <div
                style={{
                  padding:
                    "15px 20px",

                  borderBottom:
                    "1px solid #ddd",

                  background:
                    "#f8f9fa"
                }}
              >

                <div className="row">

                  <div
                    className="col-md-3"
                    style={{
                      color:
                        "black"
                    }}
                  >

                    <strong>
                      MR No.
                    </strong>

                    <br />

                    {formData.mr_no ||
                      selectedVisit.mr_no ||
                      "-"}

                  </div>


                  <div
                    className="col-md-3"
                    style={{
                      color:
                        "black"
                    }}
                  >

                    <strong>
                      Name
                    </strong>

                    <br />

                    {formData.name}

                  </div>


                  <div
                    className="col-md-3"
                    style={{
                      color:
                        "black"
                    }}
                  >

                    <strong>
                      Phone
                    </strong>

                    <br />

                    {formData.phone}

                  </div>


                  <div
                    className="col-md-3"
                    style={{
                      color:
                        "black"
                    }}
                  >

                    <strong>
                      Age
                    </strong>

                    <br />

                    {formData.age}

                  </div>

                </div>

              </div>


              {/* PRESCRIPTION */}

              <div
                style={{
                  padding:
                    "20px",

                  overflowY:
                    "auto",

                  flex: 1
                }}
              >

                {!popupEditMode ? (

                  <div
                    style={{
                      minHeight:
                        "250px",

                      border:
                        "1px solid #ddd",

                      borderRadius:
                        "6px",

                      padding:
                        "15px",

                      background:
                        "#fafafa",

                      color:
                        "#000",

                      whiteSpace:
                        "pre-wrap",

                      fontFamily:
                        "Anek Malayalam, Noto Sans Malayalam, sans-serif",

                      fontSize:
                        "16px",

                      lineHeight:
                        "1.6"
                    }}
                  >

                    {selectedVisit.prescription
                      ? selectedVisit.prescription
                      : "No prescription available."}

                  </div>

                ) : (

                  <textarea
                    value={
                      popupPrescription
                    }
                    onChange={e =>
                      setPopupPrescription(
                        e.target.value
                      )
                    }
                    style={{
                      width:
                        "100%",

                      minHeight:
                        "350px",

                      padding:
                        "15px",

                      border:
                        "1px solid #ccc",

                      borderRadius:
                        "6px",

                      resize:
                        "vertical",

                      fontFamily:
                        "Anek Malayalam, Noto Sans Malayalam, sans-serif",

                      fontSize:
                        "16px",

                      lineHeight:
                        "1.6",

                      outline:
                        "none"
                    }}
                  />

                )}

              </div>


              {/* FOOTER */}

              <div
                style={{
                  padding:
                    "15px 20px",

                  borderTop:
                    "1px solid #ddd",

                  display:
                    "flex",

                  justifyContent:
                    "flex-end",

                  gap:
                    "10px"
                }}
              >

                {!popupEditMode ? (

                  <>

                    <button
                      className="btn btn-warning"
                      onClick={() =>
                        setPopupEditMode(
                          true
                        )
                      }
                    >

                      <i className="fa fa-edit"></i>

                      {" "}

                      Edit

                    </button>


                    <button
                      className="btn btn-secondary"
                      onClick={() => {

                        setShowPrescriptionPopup(
                          false
                        );

                        setPopupEditMode(
                          false
                        );

                      }}
                    >
                      Close
                    </button>

                  </>

                ) : (

                  <>

                    <button
                      className="btn btn-success"
                      onClick={
                        handlePopupUpdate
                      }
                    >

                      <i className="fa fa-save"></i>

                      {" "}

                      Save Update

                    </button>


                    <button
                      className="btn btn-secondary"
                      onClick={() => {

                        setPopupPrescription(
                          selectedVisit.prescription ||
                          ""
                        );

                        setPopupEditMode(
                          false
                        );

                      }}
                    >
                      Cancel
                    </button>

                  </>

                )}

              </div>

            </div>

          </div>

        )}

    </div>

  );

}